__turbopack_context__.v({
  "component": "style-module-scss-module__Ne77Oq__component",
  "logos-row": "style-module-scss-module__Ne77Oq__logos-row",
});
